module.exports = __webpack_public_path__ + "static/media/stripe-logo.7a839861.webp";